import Papa from 'papaparse';

export const fetchData = async (holeDataUrl, assayDataUrl, holeColumns, assayColumns, surveyDataUrl = null) => {
  const parseCSV = (url) => {
    if (!url) {
      return Promise.resolve([]);
    }
    return new Promise((resolve, reject) => {
      Papa.parse(url, {
        download: true,
        header: true,
        complete: (result) => {
          resolve(result.data);
        },
        error: (error) => {
          reject(error);
        },
      });
    });
  };

  const holeData = await parseCSV(holeDataUrl);
  const assayData = await parseCSV(assayDataUrl);
  
  let surveyData = {};
  if (surveyDataUrl) {
    try {
      const surveyRawData = await parseCSV(surveyDataUrl);
      surveyRawData.forEach((survey) => {
        const holeId = survey.Hole_ID;
        if (!holeId || holeId.length < 1) return;
        if (!surveyData[holeId]) {
          surveyData[holeId] = [];
        }
        // Store survey records sorted by depth
        surveyData[holeId].push({
          depth: parseFloat(survey.Depth) || 0,
          dip: parseFloat(survey.Dip) || 0,
          azimuth: parseFloat(survey.NAT_Azimuth) || 0,
        });
      });
      // Sort each hole's survey data by depth
      Object.keys(surveyData).forEach((holeId) => {
        surveyData[holeId].sort((a, b) => a.depth - b.depth);
      });
    } catch (error) {
      console.warn('Failed to load survey data:', error);
      surveyData = {};
    }
  }

  const holes = {};
  const assays = {};
  holeData.forEach((hole) => {
    const holeId = hole[holeColumns['Hole No']];
    if (!holeId || holeId.length < 1) {
      return;
    }
    holes[holeId] = { ...hole };
  });

  if (Array.isArray(assayData) && assayData.length > 0) {
    assayData.forEach((assay) => {
      const holeId = assay?.[assayColumns['HoleID']];
      if (!holeId) return;
      if (!assays[holeId]) {
        assays[holeId] = [];
      }
      assays[holeId].push({ ...assay });
    });
  }

  return { holes, assays, surveys: surveyData };
};
